import React from 'react';
import { ThemeProvider as MuiThemeProvider, createTheme } from '@mui/material/styles';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';

import light from '../src/styles/themes/light';

const muiTheme = createTheme();

export function wrapRootElement({ element }) {
  return (
    <MuiThemeProvider theme={muiTheme}>
      <StyledThemeProvider theme={light}>{element}</StyledThemeProvider>
    </MuiThemeProvider>
  );
}

